<template>
  <div class="position-relative cfs-loading-overlay fill-height">
    <div v-if="loading" class="cfs-loading-overlay__loading position-absolute">
      <div class="fill-height w100 d-flex align-center justify-center">
        <v-progress-circular :size="50" color="primary" indeterminate />
      </div>
    </div>

    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CfsLoadingOverlay',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
.cfs-loading-overlay {
  &__loading {
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background-color: rgba(251, 253, 255, 0.75);
  }
}
</style>
